import $ from 'jquery';
import slick from  '../vendors/slider.min';

import ScrollMagic from 'scrollmagic';
import TweenMax from 'gsap';
import TimelineMax from 'gsap/TimelineMax';
import 'scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';
import 'scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators.js';

class BjzmScripts {
	
	constructor() {
		 this.do_hamburger();
		 this.doSliders();
		 this.doScrollMagic();
		 this.isHamburgerOpen = false;
		 this.setTouchScreenClasses(".button, .navigation__link");
		 this.mobileHeader = $(".header--mobile");

		 setTimeout(function(){
		 	// $(".hero").addClass('animating');
		 }, 200);
		 // $(window).scrollTop(0);

	}

	do_hamburger() {
		var self = this;
		$(".hamburger__inner").click(function(e){
			e.preventDefault();
			if( self.isHamburgerOpen ) {
				self.closeMobileMenu();
			}
			else {
				self.openMobileMenu();
			}
		})
	}

		doScrollMagic() {
		var controller = new ScrollMagic.Controller();
		$('.bjzm-gallery__item, .bjzm-form_wrapper').each(function(){
		 // Create a scene for each project
		 var myScene = new ScrollMagic.Scene({
		 	triggerElement: this,
		 	triggerHook: 0.8
		 })
		 .setClassToggle(this, 'animate')
		 .reverse(false)
		 // .addIndicators({name: "1 (duration: 0)"})
		 .addTo(controller);
		});
	}


	doSliders() {
		if( $(".bjzm-slideshow__list").length > 0 ) {
			
			$(".bjzm-slideshow__list").slick({ 
				dots: false,
				centerPadding: '20px',
		 		slidesToShow: 1,
		 		variableWidth: true,
		 		adaptiveHeight: true,
		 		arrows: false,
	            dotsClass: 'custom_paging',
	            infinite: true,
	            autoplay: true,
	            autoplaySpeed: 3000,
	            pauseOnHover: true,
	            useCSS: true,
	            centerMode: true,
	            cssEase: 'ease-in-out'
		 	});
			$(".bjzm-slideshow__nav-link--prev").on('click', function(e){
				e.preventDefault();
				$(".bjzm-slideshow__list").slick('slickPrev');
			})
			$(".bjzm-slideshow__nav-link--next").on('click', function(e){
				e.preventDefault();
				$(".bjzm-slideshow__list").slick('slickNext');
			})
		} 	
	}

	openMobileMenu() {
		this.mobileHeader.addClass("header--mobile-menu-active");
		this.isHamburgerOpen = true;
	}

	closeMobileMenu() {
		this.mobileHeader.removeClass("header--mobile-menu-active");
		this.isHamburgerOpen = false;
	}


	is_touch_device() {
		return (('ontouchstart' in window)
			|| (navigator.MaxTouchPoints > 0)
			|| (navigator.msMaxTouchPoints > 0));
	}

	getTouchClass() {
		return ( this.is_touch_device() ) ? ' touch-screen' : ' desktop-screen';
	}

	setTouchScreenClasses(selectors) {

		var classes = this.getTouchClass();
		$(selectors).addClass( classes );
	}

	

	
}

module.exports = BjzmScripts;